import * as React from "react";

import type { WizardContextValue } from "./Wizard.types";

export const WizardContext = React.createContext<WizardContextValue | null>(
  null,
);

export function useWizardContext(componentName: string): WizardContextValue {
  const context = React.useContext(WizardContext);

  if (!context) {
    throw new Error(`${componentName} must be used within a Wizard.`);
  }

  return context;
}

export function useWizard(): WizardContextValue {
  return useWizardContext("useWizard");
}
